module.exports = __webpack_public_path__ + "static/media/check.03da0677.svg";